import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPDesktopHeroGallery from '../PDPDesktopHeroGallery';
import PDPDesktopGalleryRevamp from '../PDPDesktopGalleryRevamp';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPDesktopMarxentConfigurator from '../../modular-configurator/PDPMarxentConfigurator';
import useIsGalleryRevampVariant from '../useIsGalleryRevampVariant';
const PDPDesktopPhotoPanelInner = t0 => {
  const $ = _c(14);
  const {
    isEditOrder: t1,
    pdpIsModularBYOProduct: t2,
    slug,
    hideMarxent: t3,
    unavailableFabric: t4,
    productHeroImage: t5,
    productCylindoHeroImage: t6
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const hideMarxent = t3 === undefined ? true : t3;
  const unavailableFabric = t4 === undefined ? false : t4;
  const productHeroImage = t5 === undefined ? null : t5;
  const productCylindoHeroImage = t6 === undefined ? null : t6;
  const isGalleryRevampVariant = useIsGalleryRevampVariant();
  let t7;
  if ($[0] !== hideMarxent || $[1] !== isEditOrder || $[2] !== isGalleryRevampVariant || $[3] !== pdpIsModularBYOProduct || $[4] !== productCylindoHeroImage || $[5] !== productHeroImage || $[6] !== slug || $[7] !== unavailableFabric) {
    t7 = pdpIsModularBYOProduct ? <PDPDesktopMarxentConfigurator pdpIsModularBYOProduct={pdpIsModularBYOProduct} slug={slug} key={slug} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} /> : isGalleryRevampVariant ? <PDPDesktopGalleryRevamp slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} /> : <PDPDesktopHeroGallery isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} />;
    $[0] = hideMarxent;
    $[1] = isEditOrder;
    $[2] = isGalleryRevampVariant;
    $[3] = pdpIsModularBYOProduct;
    $[4] = productCylindoHeroImage;
    $[5] = productHeroImage;
    $[6] = slug;
    $[7] = unavailableFabric;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== isEditOrder) {
    t8 = !isEditOrder && <PDPKeySellingPoints />;
    $[9] = isEditOrder;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <div className="sticky top-8">{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
PDPDesktopPhotoPanelInner.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  slug: PropTypes.string,
  hideMarxent: PropTypes.bool,
  unavailableFabric: PropTypes.bool,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
const PDPDesktopPhotoPanel = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPDesktopPhotoPanelInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPDesktopPhotoPanel;